import React, { useState } from 'react';
import { Image } from "react-bootstrap";
import { NavigationTab, LogoutTab } from 'Navigation/Components';
import { BiLandscape, BiSearchAlt, BiLogOut, BiSitemap, BiBuildings } from 'react-icons/bi';
import { AiOutlineUser } from 'react-icons/ai';
import { FiSettings } from 'react-icons/fi';
import { FaConnectdevelop, FaDatabase } from 'react-icons/fa';
import { RiAdminLine } from 'react-icons/ri';
import { BsCloud, BsJournalBookmark } from 'react-icons/bs';
import { MdOutlineSecurity } from 'react-icons/md';
import { FcExpand, FcCollapse } from 'react-icons/fc';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { FaGlobe } from "react-icons/fa";
import SectionHeader from './SectionHeader';

import './Navigation.css';

const Navigation = (props) => {
  const [isSettingsExpanded, setIsSettingsExpanded] = useState(false);
  // Runtime feature flag from the advanced-config settings (replaces the old build-time
  // REACT_APP_PROFILE_ENABLED). Passed down from App, which loads it on boot.
  // Default-on: only an explicit false hides the item.
  const profileEnabled = props.profileEnabled !== false;

  return (
    <div 
      role="navigation" 
      aria-label="navigation"
      className='navigation'
    >
      <div>
        <Image 
          alt="C2 Discover Logo" 
          className='navigation-c2-logo' 
          src="/c2_platform_white.png" 
        />
      </div>
        <PerfectScrollbar>
          <div className='d-flex flex-column h-100'>
            <div>
              {/* Landscape for the wider estate. Every data source appears on both
                  landscapes — the per-source landscape split was removed 2026-09-24. */}
              <NavigationTab
                tooltip='Where the estate risk sits, who owns it, and what changed since the last scan'
                path='/enterprise'
                icon={BiBuildings}
                text='Enterprise Data Landscape'
                testId='nav-enterprise'
              />
              {/* Pinned above the Discover section — the product home page ('/' selects it). */}
              <NavigationTab
                tooltip='See your risk overview'
                path='/landscape'
                home={true}
                icon={BiLandscape}
                text='Data Privacy Workflow'
                testId='nav-landscape'
              />
              {/* Schema Intelligence is the Profile section's only item, so the whole section
                  (header included) is gated behind PROFILE_ENABLED — an empty header
                  otherwise. */}
              {profileEnabled && (
                <>
                  <SectionHeader title='Profile' />
                  <NavigationTab
                    tooltip='Cross-source schema identities and lineage'
                    path='/metadata'
                    icon={BiSitemap}
                    text='Schema Intelligence'
                    exactPath={false}
                    testId='nav-schema-intelligence'
                  />
                </>
              )}
              <SectionHeader title='Discover' />
              <NavigationTab
                tooltip='Run new data Discovery jobs'
                path='/discover'
                icon={BiSearchAlt}
                text='Data Discovery'
                testId='nav-discovery'
              />
              <SectionHeader title='Secure' />
              <NavigationTab
                tooltip='View your secured data'
                path='/secure'
                icon={MdOutlineSecurity}
                text='Secure Data Landscape'
                exactPath={true}
              />
              <NavigationTab
                tooltip='Review and edit masking inventories across all discovered data sources'
                path='/inventory-manager'
                icon={BsJournalBookmark}
                text='Inventory Manager'
                exactPath={false}
              />
              <NavigationTab
                tooltip='Run masking jobs serially as ordered groups, including fan-outs'
                path='/secure/groups'
                icon={BiSitemap}
                text='Orchestration Groups'
                exactPath={true}
              />
              <SectionHeader title='Manage' />
              <NavigationTab
                tooltip='Coming soon'
                exactPath={false}
                path='/manage'
                icon={BsCloud}
                text='Cloud Landscape'
              />
            </div>
            <div className='d-flex flex-column flex-grow-1 justify-content-end'>
              <div>
                <button
                  type='button'
                  className='nav-section-header settings-accordion-toggle'
                  onClick={() => setIsSettingsExpanded(!isSettingsExpanded)}
                  aria-expanded={isSettingsExpanded}
                  aria-controls='settings-sub-items'
                >
                  <span>Settings</span>
                  <span className='settings-accordion-caret'>
                    {isSettingsExpanded ? <FcCollapse /> : <FcExpand />}
                  </span>
                </button>
                {isSettingsExpanded && (
                  <div id='settings-sub-items'>
                    <NavigationTab
                      tooltip='Manage your data sources'
                      path='/sources'
                      icon={FaConnectdevelop}
                      text='Data sources'
                      testId='nav-data-sources'
                    />
                    <NavigationTab
                      tooltip='Manage your sampling rules'
                      path='/rules'
                      icon={FiSettings}
                      text='Sampling Rules'
                    />
                    <NavigationTab
                      tooltip='View and upload JDBC drivers'
                      path='/drivers'
                      icon={FaDatabase}
                      text='Drivers'
                      exactPath={true}
                    />
                    <NavigationTab
                      tooltip='View and manage your user settings'
                      path='/user'
                      icon={AiOutlineUser}
                      text='My User'
                      exactPath={true}
                    />
                    { props.isAdmin &&
                      <NavigationTab
                        tooltip='Register and configure 3rd-party service integrations'
                        path='/integrations'
                        icon={FaGlobe}
                        text='Integrations'
                        exactPath={true}
                      />
                    }
                    { props.isAdmin &&
                      <NavigationTab
                        tooltip='Manage users and user privileges'
                        path='/admin'
                        icon={RiAdminLine}
                        text='Admin Panel'
                      />
                    }
                    { props.isAdmin &&
                      <NavigationTab
                        tooltip='Fallback credentials for data sources the workload identity cannot reach'
                        path='/cloud-accounts'
                        icon={BsCloud}
                        text='Alternate Credentials'
                      />
                    }
                  </div>
                )}
                <LogoutTab
                  tooltip='Logout of current user'
                  icon={BiLogOut}
                  text='Logout'
                />
              </div>
            </div>
          </div>
        </PerfectScrollbar>
    </div>
  );
}

export default Navigation;